<template>
<MDBContainer>
  <MDBRow>
    <MDBCol col="6">
      <img class="icon-attr" :src="'images/' + this.attr + '.png'" />
      <h3>{{ data.name }}</h3>
    </MDBCol>
    <MDBCol col="3">
      <div v-if="active">
        Range: {{ data.range }}<br />AP Cost: {{ data.AP }}
      </div>
    </MDBCol>
    <MDBCol col="3" class="skill-area">
      <table>
        <tbody>
          <tr>
            <td :style="checkstyle(7)"></td>
            <td :style="checkstyle(8)"></td>
            <td :style="checkstyle(9)"></td>
          </tr>
          <tr>
            <td :style="checkstyle(4)"></td>
            <td :style="checkstyle(5)"></td>
            <td :style="checkstyle(6)"></td>
          </tr>
          <tr>
            <td :style="checkstyle(1)"></td>
            <td :style="checkstyle(2)"></td>
            <td :style="checkstyle(3)"></td>
          </tr>
        </tbody>
      </table>
    </MDBCol>
  </MDBRow>
  <div v-html="description" class="mt-4 skill-desciption"></div>
</MDBContainer>
</template>
<script>
import { MDBCol, MDBRow, MDBContainer } from "mdb-vue-ui-kit";
export default {
  components: {
    MDBCol,
    MDBRow,
    MDBContainer,
  },
  props: ["data", "atk"],
  data() {
    return {};
  },
  computed: {
    attr() {
      var attr = "normal";
      if (this.data.attr != undefined) {
        attr = this.data.attr;
      }
      return attr;
    },
    active() {
      return this.data.type == "active";
    },
    mark() {
      return this.data.area[0][1] == ">";
    },
    center() {
      if (this.mark) {
        let center;
        let mark = this.data.area[0];
        if (mark[0] == "F") {
          center = null;
        } else {
          center = parseInt(mark[0]);
        }
        return center;
      } else return 5;
    },
    multiplier() {
      let area;
      if (this.mark) {
        area = this.data.area.slice(1);
      } else {
        area = this.data.area;
      }
      if (area[0] < 1) {
        return area;
      }
      else if (area[0] == 1 && area.length == 9 && area[8] != 9) {
        return area
      } 
      else {
        let area2 = [0, 0, 0, 0, 0, 0, 0, 0, 0];
        area.forEach((element) => {
          area2[element - 1] = 1;
        });
        return area2;
      }
    },
    skillrate() {
      if (this.data.description.match(/\$\((\d+\.*\d*)\)/)) {
        return this.data.description.match(/\$\((\d+\.*\d*)\)/)[1];
      } else return null;
    },
    description() {
      if (this.skillrate) {
        return this.data.description.replace(
          /\$\(\d+\.*\d*\)/g,
          Math.floor(this.atk * this.skillrate)
        );
      } else return this.data.description;
    },
  },
  methods: {
    checkstyle(loc) {
      var bg_color = "rgb(45, 45, 45)";
      var cen_color = "rgb(22, 155, 155)";
      let cur_color;
      if (loc == this.center) {
        cur_color = cen_color;
      } else {
        cur_color = bg_color;
      }
      let color;
      if (this.multiplier[loc - 1] == 0) {
        color = "rgba(0, 0, 0, 0)";
      } else {
        color =
          "rgb(200, " +
          Math.round(
            ((200 - 128) / 0.5) * (this.multiplier[loc - 1] - 0.5) + 128
          ) +
          ", 0)";
      }
      return (
        "background-image: linear-gradient(to right, " +
        color +
        ", " +
        color +
        "), linear-gradient(to right, " +
        cur_color +
        "," +
        cur_color +
        ")"
      );
    },
  },
};
</script>
<style scoped>
.icon-attr {
  width: 1em;
  display: inline;
  vertical-align: middle;
  margin-right: 0.2em;
}

.skill-area table {
  height: 100px;
  width: 100px;
  margin: 0 auto;
}

.skill-area tbody {
  transform: skewX(-10deg);
}

.skill-area td {
  box-sizing: content-box;
  /* background: rgb(45, 45, 45); */
  width: 33%;
  height: 0;
  border-radius: 5%;
  background-position: -4px -4px, 4px 4px;
  background-size: 100%, 100%;
  background-repeat: no-repeat;
}

.skill-desciption >>> strong {
  display:inline !important;
  background-color: #eee;
  border-radius: 3px;
  padding: 1px 4px;
}
</style>
